export default "__VITE_ASSET__DOlp5A5Z__"